import { useSelector } from "react-redux";
import { selectCurrentUser } from "../store/auth.duck";
import { User } from '@shared/models/user.models';

export function WithCurrentUser(): User | undefined {
  const user = useSelector(selectCurrentUser);
  return user;
}

